import { ActionReducer } from '@ngrx/store';
import { storage } from '@lib/utils/storage/storage.utils';
import { clearAppSession, hydrateAppSession, setAppSession } from './app-session.actions';
import { AppSessionState } from './app-session.state';

const sessionPersistActions = new Set<string>([setAppSession.type, hydrateAppSession.type, clearAppSession.type]);

export function appSessionStorageMetaReducer(
    reducer: ActionReducer<AppSessionState | null>,
): ActionReducer<AppSessionState | null> {
    return (state, action) => {
        const nextState = reducer(state, action);

        if (!sessionPersistActions.has(action.type)) {
            return nextState;
        }

        if (nextState) {
            storage.setItem('appSession', nextState);
        } else {
            storage.removeItem('appSession');
        }

        return nextState;
    };
}
